import { IPoint } from "../interfaces";

export class CADDrawingUnitHelper {

    #imageRatio: number;
    #imageOffset: IPoint;
    #canvasRatio: number;
    #canvasOffset: IPoint;

    constructor(imageRatio: number, imageOffset: IPoint, canvasRatio: number, canvasOffset: IPoint) {
        this.#imageRatio = imageRatio;
        this.#imageOffset = imageOffset;
        this.#canvasRatio = canvasRatio;
        this.#canvasOffset = canvasOffset;
    }

    public UpdateImageInfo(imageRatio: number, imageOffset: IPoint): void {
        this.#imageRatio = imageRatio;
        this.#imageOffset = imageOffset;
    }

    public UpdateCanvasInfo(canvasRatio: number, canvasOffset: IPoint): void {
        this.#canvasRatio = canvasRatio;
        this.#canvasOffset = canvasOffset;
    }

    public GetImageRatio(): number {
        return this.#imageRatio;
    }

    public GetImageOffset(): IPoint {
        return this.#imageOffset;
    }

    public GetCanvasRatio(): number {
        return this.#canvasRatio;
    }

    public GetCanvasOffset(): IPoint {
        return this.#canvasOffset;
    }


    public ConvertModelPointToImageSpace(point: IPoint): IPoint {
        const x = point.x * this.#imageRatio + this.#imageOffset.x;
        const y = point.y * this.#imageRatio + this.#imageOffset.y;
        return { x, y };
    }

    public ConvertImagePointToModelSpace(point: IPoint): IPoint {
        const x = (point.x - this.#imageOffset.x) / this.#imageRatio;
        const y = (point.y - this.#imageOffset.y) / this.#imageRatio
        return { x, y };
    }


    public ConvertImagePointToCanvasSpace(point: IPoint): IPoint {
        const x = point.x * this.#canvasRatio + this.#canvasOffset.x;
        const y = point.y * this.#canvasRatio + this.#canvasOffset.y;
        return { x, y };
    }

    public ConvertCanvasPointToImageSpace(point: IPoint): IPoint {
        const x = (point.x - this.#canvasOffset.x) / this.#canvasRatio;
        const y = (point.y - this.#canvasOffset.y) / this.#canvasRatio;
        return { x, y };
    }

    public ConvertModelPointToCanvasSpace(point: IPoint): IPoint {
        return this.ConvertImagePointToCanvasSpace(this.ConvertModelPointToImageSpace(point));
    }

    public ConvertCanvasPointToModelSpace(point: IPoint): IPoint {
        return this.ConvertImagePointToModelSpace(this.ConvertCanvasPointToImageSpace(point));
    }

    public ConvertModelDistanceToCanvasSpace(distance: number): number {
        return distance * this.#canvasRatio * this.#imageRatio;
    }

    public ConvertCanvasDistanceToModelSpace(distance: number): number {
        return distance / (this.#canvasRatio * this.#imageRatio);
    }


}